import { NAME_ACCESSOR } from '../../constants.js';
import { useNameAccessor } from '../../context/NameAccessorContext.js';
import { TreeMapCategoricalLegend } from './TreeMapCategoricalLegend.js';
import { TreeMapRangeLegend } from './TreeMapRangeLegend.js';

const TREEMAP_LEGEND_RENDERERS = {
  categorical: <TreeMapCategoricalLegend />,
  range: <TreeMapRangeLegend />,
};

export const TreeMapLegendRenderer = () => {
  const nameAccessor = useNameAccessor();

  const legendType =
    nameAccessor === NAME_ACCESSOR.Value ? 'range' : 'categorical';

  return TREEMAP_LEGEND_RENDERERS[legendType];
};
